import { Link } from "react-router-dom";
import { ExternalLink, Globe } from "lucide-react";
import { TeamData } from "@/types/auth/auth";
import { Agent } from "@/types/agent/agent";
import AccessGrantsSection from "./AccessGrantsSection";
import PasswordAccessSection from "./PasswordAccessSection";
import TeamAccessSection from "./TeamAccessSection";

interface ManageAccessSectionProps {
  genie: Agent;
  team: TeamData | undefined;
  shareUrl: string;
  userId: string;
  onClose: () => void;
}

export default function ManageAccessSection({ genie, team, shareUrl, userId, onClose }: ManageAccessSectionProps) {
  if (genie.is_public) {
    return (
      <div className="pt-4">
        <div className="rounded-xl border border-blue-200 bg-blue-50 p-4 flex items-start gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-100">
            <Globe className="h-4.5 w-4.5 text-blue-600" />
          </div>
          <div>
            <p className="text-sm font-semibold text-blue-900">This genie is public</p>
            <p className="text-sm text-blue-800 mt-1">
              Anyone with the link can access this genie. There's no access management for public genies — make it
              private first if you need to restrict who can use it.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4">
      <Link
        to={`/genie-hub/activation/genie/${genie.id}#activate-invite`}
        onClick={onClose}
        className="flex items-center justify-between gap-2 rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition-colors mb-6"
      >
        <span>Invite people & view requests</span>
        <ExternalLink className="h-3.5 w-3.5 shrink-0" />
      </Link>
      <div className="space-y-4">
        {team && <TeamAccessSection genie={genie} team={team} shareUrl={shareUrl} userId={userId} />}
        <PasswordAccessSection genie={genie} shareUrl={shareUrl} />
        <AccessGrantsSection genie={genie} shareUrl={shareUrl} />
      </div>
    </div>
  );
}
